
export default {
    setAreaAtuacao(state, data) {
        state.areaAtuacao = data
    },
    setAreasAtuacoes(state, data) {
        state.areasAtuacoes = data
    }
}